<div class="input-wrapper">
  @switch (inputFieldType) {
    @case ('FREE_TEXT') {
      <app-text-input
        [field]="field"
        [label]="label"
        placeholder="TRANS__ADVANCED_SEARCH__FREE_TEXT_SEARCH_PLACEHOLDER"
        (searchValueChanged)="handleSearchValueChanged($event)"
      ></app-text-input>
    }

    @case ('TEXT') {
      <app-text-input
        [field]="field"
        [label]="label"
        placeholder="TRANS__ADVANCED_SEARCH__TEXT_SEARCH_PLACEHOLDER"
        (searchValueChanged)="handleSearchValueChanged($event)"
      ></app-text-input>
    }

    @case ('NUMBER') {
      <app-number-input
        [field]="field"
        [label]="label"
        placeholder="TRANS__ADVANCED_SEARCH__NUMBER_SEARCH_PLACEHOLDER"
        (searchValueChanged)="handleSearchValueChanged($event)"
      ></app-number-input>
    }

    @case ('BOOLEAN') {
      <app-boolean-input
        [field]="field"
        [label]="label"
        placeholder="TRANS__ADVANCED_SEARCH__CHECKBOX_SELECT_PLACEHOLDER"
        (searchValueChanged)="handleSearchValueChanged($event)"
      ></app-boolean-input>
    }

    @case ('DATE') {
      <app-date-input
        [field]="field"
        [label]="label"
        fromDatePlaceholder="TRANS__ADVANCED_SEARCH__DATE_FROM_PLACEHOLDER"
        toDatePlaceholder="TRANS__ADVANCED_SEARCH__DATE_TO_PLACEHOLDER"
        (searchValueChanged)="handleSearchValueChanged($event)"
      ></app-date-input>
    }

    @case ('SELECT') {
      <app-select-input
        [field]="field"
        [label]="label"
        [multiple]="false"
        placeholder="TRANS__ADVANCED_SEARCH__SEARCH_DROPDOWN_PLACEHOLDER"
        (searchValueChanged)="handleSearchValueChanged($event)"
      ></app-select-input>
    }

    @case ('SELECT_MULTIPLE') {
      <app-select-input
        [field]="field"
        [label]="label"
        [multiple]="true"
        placeholder="TRANS__ADVANCED_SEARCH__SEARCH_DROPDOWN_PLACEHOLDER"
        (searchValueChanged)="handleSearchValueChanged($event)"
      ></app-select-input>
    }

    @default {
      <span>
        {{ label }}
      </span>
    }
  }
</div>
